import React from "react";
// import { Responsive, WidthProvider } from "react-grid-layout";
import CurrentCoverage from "../../widgets/office/dashboard/CurrentCoverage";
import TotalOfficeStockBuild from "../../widgets/office/dashboard/TotalOfficeStockBuild";
import CurrentVacancy from "../../widgets/office/dashboard/CurrentVacancy";
import CurrentPassingRent from "../../widgets/office/dashboard/CurrentPassingRent";
import PanIndiaCommercial from "../../widgets/office/dashboard/PanIndiaCommercial";
import UpcomingSupply from "../../widgets/office/dashboard/UpcomingSupply";
import OfficeDemandSupplyChart from "../../widgets/office/dashboard/OfficeDemandSupplyChart";
import RentalsAnalysisChart from "../../widgets/office/dashboard/RentalsAnalysisChart";
import MajorRecentLeaseTransactions from "../../widgets/office/dashboard/MajorRecentLeaseTransactions";
import UpcomingProjectCompletions from "../../widgets/office/dashboard/UpcomingProjectCompletions";
import TopOfficeProjects from "../../widgets/office/dashboard/TopOfficeProjects";
import TopOfficeTenants from "../../widgets/office/dashboard/TopOfficeTenants";
import TopsectorsOfficeLeasing from "../../widgets/office/dashboard/TopsectorsOfficeLeasing";
import TopDevelopersInOfficeDevelopment from "../../widgets/office/dashboard/TopDevelopersInOfficeDevelopment";
import MajorRecentSaleTransactions from "../../widgets/office/dashboard/MajorRecentSaleTransactions";
import AssetSummary from "../../widgets/office/dashboard/AssetSummary";
// import LatestNews from "../../../widgets/office/LatestNews";
import RecentSearches from "../../widgets/office/dashboard/RecentSearches";
import SavedFilters from "../../widgets/office/dashboard/SavedFilters";
import RecentTransactions from "../../widgets/office/dashboard/RecentTransactions";
import OccupiedStock from "../../widgets/office/dashboard/OccupiedStock";
import MarketRent from "../../widgets/office/dashboard/MarketRent";
import RentBySectors from "../../widgets/office/dashboard/RentBySectors";
import StockDemandSupplyVacancy from "../../widgets/office/dashboard/StockDemandSupplyVacancy";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import RecentNews from "../../widgets/office/dashboard/RecentNews";
import Button from "react-bootstrap/Button";

// const ResponsiveGridLayout = WidthProvider(Responsive);

class Dashboard extends React.Component {
  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
  }
  render() {
    return (
      <div className="container-fluid dashboard" id="dash">
        <div className="row ">
          <div
            className="col-12 mb-4 text-end"
            style={{
              position: "fixed",
              bottom: "1px",
              zIndex: "999",
              right: "60px",
            }}
          >
            {/* <Button variant="outline-primary">Master Toggle</Button> */}
          </div>
          <div className="col-lg-9">
            <div className="newDashboard dashboardWidgetRow">
              <div className="newDashboardInner">
                <CurrentCoverage />
              </div>
              <div className="newDashboardInner">
                <TotalOfficeStockBuild />
              </div>
              <div className="newDashboardInner">
                <OccupiedStock />
              </div>
              <div className="newDashboardInner">
                <CurrentVacancy />
              </div>
              <div className="newDashboardInner">
                <MarketRent />
              </div>
              <div className="newDashboardInner">
                <CurrentPassingRent />
              </div>
              <div className="newDashboardInner">
                <PanIndiaCommercial />
              </div>
              <div className="newDashboardInner">
                <UpcomingSupply />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-6">
                <OfficeDemandSupplyChart />
              </div>
              <div className="col-lg-6">
                <RentalsAnalysisChart />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8">
                <MajorRecentLeaseTransactions />
              </div>

              <UpcomingProjectCompletions />
            </div>
            <div className="row mt-4">
              <TopOfficeProjects />
              <TopOfficeTenants />
            </div>
            <div className="row mt-4">
              <div className="col-lg-6">
                <TopsectorsOfficeLeasing />
              </div>
              <div className="col-lg-6">
                <TopDevelopersInOfficeDevelopment />
              </div>
            </div>
            <div className="row mt-4">
              <MajorRecentSaleTransactions />
            </div>
            <div className="row mt-4">
              <div className="col-lg-12">
                <AssetSummary />
              </div>
              <div className="col-lg-12 mt-3">
                <RentBySectors />
              </div>
              <div className="col-lg-12 mt-3">
                <StockDemandSupplyVacancy />
              </div>
              <div className="col-lg-12 mt-3">
                <RecentNews />
              </div>
            </div>
            <div className="row mt-4"></div>
          </div>
          <div className="col-lg-3 rightSideBar">
            <RecentSearches />
            {/* <SavedFilters /> */}
            <RecentTransactions />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            {/* <Map /> */}
            {/* <Map1 zoom={2} styleProp={{ height: "100vh", width: "100vh" }} />
            <MajorRecentSaleTransactions /> */}
          </div>
        </div>
      </div>
    );
  }
}
export default Dashboard;
